<script setup>
import {onMounted, ref, inject} from 'vue'
import axios from 'axios'

onMounted(async () => {
    await getOrganizers(organizersUrl)
})

const contentData = inject('contentData')
const backEndURL = process.env.VUE_APP_BACKEND_URL
const title = 'Organizers'
const organizers = ref([])
const organizersUrl = 'api/organizers'

const getOrganizers = async url => {
    try {
        const response = await axios.get(`${backEndURL}/${url}`)
        organizers.value = response.data
    } catch (err) {
        console.log(err)
    }
}
</script>

<template>
    <section class="bg-gray-50 py-10 sm:py-16">
        <div class="container mx-auto px-4 sm:px-6">
            <div class="max-w-3xl mx-auto text-center">
                <h1 class="font-heading mb-5 mt-2 text-3xl uppercase sm:mb-6 sm:text-4xl">
                    {{ $t('organizers.title') }}
                </h1>
            </div>
            <div class="-mb-5 flex flex-wrap justify-evenly sm:-mx-4 sm:-mb-8">
                <div class="mb-5 w-full px-0 sm:mb-8 sm:w-1/2 sm:px-4 xl:w-1/3" v-for="organizer in organizers">
                    <div class="rounded-lg bg-white px-5 pb-6 pt-7 text-center sm:px-6 sm:pb-8 sm:pt-10">
                        <img
                            class="mx-auto mb-6 block h-28 w-28 rounded-full object-scale-down sm:mb-8 sm:h-36 sm:w-36"
                            :src="organizer.image ? organizer.image : require('@/assets/placeholder.jpg')"
                            :alt="organizer.name" />
                        <h4 class="font-heading leading-7 text-lg font-medium">{{ organizer.name }}</h4>
                        <p class="leading-7 text-gray-400" v-for="role in organizer.roles">
                            {{ role }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<style scoped></style>
